import React from 'react';
import classnames from 'classnames';
import { SwitchOn, SwitchOff } from '../../../icons/Switch'

import classes from './Switch.module.scss';

type SwitchProps = {
  // will be added to the top level container, not the icon itself
  className?: string;
  // will be added to the top level container, not the icon itself
  style?: any;
  // if active, switch is to the right and background turns blue. Label colors also change based on active/inactive
  active: boolean;
  // cb to call when switch icon is clicked
  onClick?: any
  // text that shows to the left of the switch icon
  leftLabel?: string;
  // text that shows to the right of the switch icon
  rightLabel?: string;
  // if disabled, the colors are faded. Click events are still controlled by parent though
  disabled?: boolean;
}

function Switch({
  className = '',
  style = {},
  active,
  onClick,
  leftLabel = '',
  rightLabel = '',
  disabled
}: SwitchProps) {
  let backgroundFill, circleFill;
  if (disabled) {
    backgroundFill = '#EEEFF2';
    circleFill = '#D2D3DB';
  }

  let switchIcon = <SwitchOff
    backgroundFill={backgroundFill}
    circleFill={circleFill}
  />
  if (active) switchIcon = <SwitchOn
    backgroundFill={backgroundFill}
    circleFill={circleFill}
  />

  return (
    <div
      style={style}
      className={classnames(classes.switchContainer, className)}
    >
      {
        leftLabel && (
          <p className={classnames(
            classes.switchLabel,
            classes.labelMarginRight,
            {
              [classes.activeLabel]: !active,
              [classes.disabledLabel]: disabled,
            }
          )}>
            {leftLabel}
          </p>
        )
      }
      <div
        className={classes.switchIconContainer}
        onClick={onClick}
      >
        {switchIcon}
      </div>
      {
        rightLabel && (
          <p className={classnames(
            classes.switchLabel,
            classes.labelMarginLeft,
            {
              [classes.activeLabel]: active,
              [classes.disabledLabel]: disabled,
            }
          )}>
            {rightLabel}
          </p>
        )
      }
    </div>
  )
};

export default Switch